import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { SellerOfTheDay } from '../../../../domain/SellerOfTheDay'

@Component({
  selector: 'bmcore-day-seller-producer-content',
  templateUrl: './bmcore-day-seller-producer-content.component.html',
  styleUrls: ['./bmcore-day-seller-producer-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreDaySellerProducerContentComponent implements OnInit {
  @Input() producer: SellerOfTheDay

  constructor() {}

  ngOnInit(): void {}
}
